import {
  MemberMessageTabNavTitle,
  MessagesLayout,
  MessagesLayoutProps
} from '.'
import { useStateWrapper } from '../../../hooks'
import { MemberMessagesQueryType } from '../../../types'
import { MemberMessage } from '../../../utils/classes/graphql'

interface MemberMessageLayoutProps
  extends Pick<
    MessagesLayoutProps<MemberMessage>,
    'headerTranslationId' | 'TabContentElement'
  > {
  memberMessagesKey: keyof MemberMessagesQueryType
  query: string
}

export const MemberMessageLayout = ({
  headerTranslationId,
  memberMessagesKey,
  query,
  TabContentElement
}: MemberMessageLayoutProps) => {
  const { StateRenderWrapper, data: messages } =
    useStateWrapper<MemberMessagesQueryType>({
      query
    })

  return (
    <StateRenderWrapper>
      {messages && (
        <MessagesLayout
          headerTranslationId={headerTranslationId}
          tabItems={messages[memberMessagesKey]}
          TabContentElement={TabContentElement}
          TabNavTitleElement={MemberMessageTabNavTitle}
        />
      )}
    </StateRenderWrapper>
  )
}
